import { Badge, Button } from 'design-system';
import { Settings2Icon } from 'lucide-react';

import type { CatalogItem } from '@/entities/catalog-item';
import getActiveColumnCount from './getActiveColumnCount';

import type { DataTableFeatures } from 'design-system';

import type { ReactTable } from '@tanstack/react-table';

const DisplaySettingsButton = ({
  table,
  open,
  onToggle
}: {
  table: ReactTable<DataTableFeatures, CatalogItem>;
  open: boolean;
  onToggle: () => void;
}) => {
  const activeColumnCount = getActiveColumnCount(table);

  return (
    <Button
      aria-expanded={open}
      className='w-[171px] justify-start px-2 whitespace-nowrap'
      size='default'
      variant='outline'
      onClick={onToggle}
    >
      <Settings2Icon />
      Display settings
      {activeColumnCount > 0 && (
        <Badge
          data-testid='display-settings-badge'
          size='sm'
          variant='accent'
        >
          {activeColumnCount}
        </Badge>
      )}
    </Button>
  );
};

export default DisplaySettingsButton;
